import { Typography, makeStyles } from "@material-ui/core";
import * as React from "react";

const useStyles = makeStyles({
  container: {
    textAlign: "center" as "center"
  },
  illustration: {
    maxWidth: "50%"
  },
  message: {
    margin: "0 0 16px"
  }
});

interface IOwnProps {
  message: string;
  imageSrc: string;
}

const PageWarning = ({ message, imageSrc }: IOwnProps) => {
  const classes = useStyles();
  return (
    <div className={classes.container}>
      <img src={imageSrc} className={classes.illustration} />
      <Typography className={classes.message} variant="h3">
        {message}
      </Typography>
    </div>
  );
};

export default React.memo(PageWarning);
